<script setup lang="ts">
const props = defineProps({
  totalPage: { type: Number, required: true },
  query: { type: String, required: true },
  now: { type: Number, required: true },
});
</script>

<template>
  <ul v-if="totalPage > 1" class="pagination">
    <!-- // totalPageが1の時は2以降は必要ないため -->
    <template v-if="totalPage >= 2">
      <!-- // 左矢印 -->
      <li v-if="now >= 2" class="arrow">
        <a :href="`?${query}=${now - 1 || 1}`">
          <img
            src="~/assets/images/arrow_left_pagenation.png"
            width="10"
            height="17"
          />
        </a>
      </li>

      <!-- // 数字の1は固定表示 -->
      <li>
        <a :href="`?${query}=1`" :class="{ active: now === 1 }"> 1 </a>
      </li>
      <!-- // totalPageが5以下の時は…が不要なのでtotalPage数に合わせて5まで書く -->
      <template v-if="totalPage <= 5">
        <li>
          <a :href="`?${query}=2`" :class="{ active: now === 2 }"> 2 </a>
        </li>
        <template v-if="totalPage >= 3">
          <li>
            <a :href="`?${query}=3`" :class="{ active: now === 3 }"> 3 </a>
          </li>
        </template>
        <template v-if="totalPage >= 4">
          <li>
            <a :href="`?${query}=4`" :class="{ active: now === 4 }"> 4 </a>
          </li>
        </template>
        <template v-if="totalPage >= 5">
          <li>
            <a :href="`?${query}=5`" :class="{ active: now === 5 }"> 5 </a>
          </li>
        </template>
      </template>
      <!-- // totalPageが6以上の時 -->
      <template v-else>
        <!-- // 現在いるページが3未満(1or 2)の時は「23…」 -->
        <template v-if="now < 5">
          <li>
            <a :href="`?${query}=2`" :class="{ active: now === 2 }"> 2 </a>
          </li>
          <li>
            <a :href="`?${query}=3`" :class="{ active: now === 3 }"> 3 </a>
          </li>
          <li>
            <a :href="`?${query}=4`" :class="{ active: now === 4 }"> 4 </a>
          </li>
          <li>
            <a :href="`?${query}=5`" :class="{ active: now === 5 }"> 5 </a>
          </li>
          <li>
            <p class="dot">...</p>
          </li>
        </template>
        <!-- // totalPageからnowを引いて2未満(1)つまりtotalPageの1個前にいる時は「…とtotalPage-2」 -->
        <template v-else-if="totalPage - now < 2">
          <li>
            <p class="dot">...</p>
          </li>
          <li>
            <a
              :href="`?${query}=${totalPage - 1}`"
              :class="{ active: now === totalPage - 1 }"
            >
              {{ totalPage - 1 }}
            </a>
          </li>
        </template>
        <!-- // それ以外の間にいる時は「…数字3つ…」 -->
        <template v-else>
          <li>
            <p class="dot">...</p>
          </li>
          <li>
            <a :href="`?${query}=${now - 1}`">
              {{ now - 1 }}
            </a>
          </li>
          <li>
            <a :href="`?${query}=${now}`" :class="{ active: now }">
              {{ now }}
            </a>
          </li>
          <li>
            <a :href="`?${query}=${now + 1}`">
              {{ now + 1 }}
            </a>
          </li>
          <li v-if="totalPage - now > 2">
            <p class="dot">...</p>
          </li>
        </template>
        <!-- // totalPage数 -->
        <li>
          <a
            :href="`?${query}=${totalPage}`"
            :class="{ active: now === totalPage }"
          >
            {{ totalPage }}
          </a>
        </li>
      </template>
    </template>
    <!-- // 右矢印 -->
    <li v-if="now < totalPage" class="arrow">
      <a :href="`?${query}=${now + 1 <= totalPage ? now + 1 : totalPage}`">
        <img
          src="~/assets/images/arrow_right_pagenation.png"
          width="10"
          height="17"
        />
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.pagination {
  margin-bottom: 15%;
  display: flex;
  align-items: center;
  justify-content: center;

  li {
    margin-right: 2.1%;
    display: flex;

    &:last-child {
      margin-right: 0;
    }

    a {
      display: flex;
      border: 1px solid #dcdcdc;
      justify-content: center;
      align-items: center;
      width: 8.5vw;
      height: 8.5vw;
      font-weight: bold;
      color: $colorBasicText;
      font-size: px(12);
    }

    p.dot {
      display: flex;
      border: 1px solid #dcdcdc;
      justify-content: center;
      align-items: center;
      width: 8.5vw;
      height: 8.5vw;
      font-weight: bold;
      color: $colorBasicText;
      font-size: px(12);
      box-sizing: border-box;
      padding-bottom: 15%;
    }

    a {
      &.active {
        background: $colorBlue;
        color: $colorWhite;
      }

      &:hover {
        opacity: 0.7;
      }
    }

    &.arrow img {
      width: 23%;
    }
  }
}

@include media(pc) {
  .pagination {
    margin-bottom: 0;

    li {
      a {
        width: 48px;
        height: 48px;
        font-size: px(18);
      }

      p.dot {
        width: 48px;
        height: 48px;
        font-size: px(18);
        padding-bottom: 10px;
      }

      &.arrow img {
        width: auto;
      }
    }
  }
}
</style>
